import React, { Component } from "react";
import AccountsList from "./AccountsList";
import AccountsAddEdit from "./AccountsAddEdit";
import NewWindow from "react-new-window";
import ReportHome from "../Report/ReportHome";
import ContraEntry from "./AccountsCE";

class Accounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "List",
      data: null,
      txnType: "",
      latest: new Date()
    };
    this.handleClick = this.handleClick.bind(this);
  }

  render() {
    if (this.state.mode === "List") {
      return <AccountsList onClick={this.handleClick} />;
    } else if (this.state.mode === "Print") {
      return (
        <>
          <NewWindow copyStyles={true}>
            <ReportHome reportType="Receipt" data={this.state.data} />
          </NewWindow>
          <AccountsList onClick={this.handleClick} />
        </>
      );
    } else {
      if (this.state.txnType === "CE") {
        return (
          <ContraEntry
            pData={this.state.data}
            onClick={this.handleClick}
            source="list"
            txnType={this.state.txnType}
          />
        );
      }
      // else if (this.state.mode === "PrintMultiple") {
      //   return (
      //     <>
      //       <NewWindow copyStyles={true}>
      //         <ReportHome reportType="ReceiptMultiple" data={this.state.data} />
      //       </NewWindow>
      //       <AccountsList onClick={this.handleClick} />
      //     </>
      //   );
      // }
      else {
        return (
          <AccountsAddEdit
            pData={this.state.data}
            onClick={this.handleClick}
            source="list"
            txnType={this.state.txnType}
          />
        );
      }
    }
  }

  handleClick(mode, data, txnType) {
    this.setState({ latest: new Date(), data, mode, txnType });
  }
}

export default Accounts;
